document.addEventListener('DOMContentLoaded', () => {

    const time = 3050;
    const step = 1;
    let animationStarted = false;

    function outNum(elemSelector) {

        let e = document.querySelector(elemSelector);
        if (e) {
            let currentText = parseInt(e.textContent, 10) || 0;
            let startText = currentText - 20;
            e.innerHTML = startText;

            let num = currentText;
            let t = Math.round(time / ((num - startText) / step));

            window.addEventListener("scroll", function () {
                if (!animationStarted) {
                    let rect = e.getBoundingClientRect();
                    let windowHeight = window.innerHeight || document.documentElement.clientHeight;
                    if (rect.top < windowHeight) {
                        animate();
                        animationStarted = true;
                    }
                }
            });

            function animate() {
                let interval = setInterval(() => {
                    startText = startText + step;
                    if (startText >= num) {
                        startText = num;
                        clearInterval(interval);
                    }
                    e.innerHTML = startText;
                }, t);
            }
        }
    }

    outNum("#number-1");
});


document.addEventListener('DOMContentLoaded', () => {

    const time2 = 3050;
    const step2 = 1;
    let animationStarted2 = false;

    function outNum(elemSelector2) {
        let e2 = document.querySelector(elemSelector2);
        if (e2) {
            let currentText2 = parseFloat(e2.textContent.replace(',', '.')) || 0;
            let startText2 = currentText2 - 20;
            e2.innerHTML = startText2.toFixed(3).replace('.', ',');

            let num2 = currentText2;
            let t2 = Math.round(time2 / ((num2 - startText2) / step2));

            window.addEventListener("scroll", function () {
                if (!animationStarted2) {
                    let rect2 = e2.getBoundingClientRect();
                    let windowHeight2 = window.innerHeight || document.documentElement.clientHeight;
                    if (rect2.top < windowHeight2) {
                        animate2();
                        animationStarted2 = true;
                    }
                }
            });

            function animate2() {
                let interval2 = setInterval(() => {
                    startText2 = startText2 + step2;
                    if (startText2 >= num2) {
                        startText2 = num2;
                        clearInterval(interval2);
                    }
                    e2.innerHTML = startText2.toFixed(3).replace('.', ',');
                }, t2);
            }
        }
    }

    outNum("#number-2");
});

document.addEventListener('DOMContentLoaded', () => {

    const time3 = 3050;
    const step3 = 1;
    let animationStarted3 = false;

    function outNum(elemSelector3) {
        let e3 = document.querySelector(elemSelector3);
        if (e3) {
            let currentText3 = parseFloat(e3.textContent.replace(',', '.')) || 0;
            let startText3 = currentText3 - 20;
            e3.innerHTML = startText3.toFixed(3).replace('.', ',');

            let num3 = currentText3;
            let t3 = Math.round(time3 / ((num3 - startText3) / step3));

            window.addEventListener("scroll", function () {
                if (!animationStarted3) {
                    let rect3 = e3.getBoundingClientRect();
                    let windowHeight3 = window.innerHeight || document.documentElement.clientHeight;
                    if (rect3.top < windowHeight3) {
                        animate3();
                        animationStarted3 = true;
                    }
                }
            });

            function animate3() {
                let interval3 = setInterval(() => {
                    startText3 = startText3 + step3;
                    if (startText3 >= num3) {
                        startText3 = num3;
                        clearInterval(interval3);
                    }
                    e3.innerHTML = startText3.toFixed(3).replace('.', ',');
                }, t3);
            }
        }
    }

    outNum("#number-3");
});
